import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Dotdotdot } from '@design-system/dotdotdot';
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { Image } from '@design-system/image';
export const GroupSignature = ({ groupName, logoSrc }) => (_jsxs(Box, { alignItems: "center", dataTestId: "group-signature", children: [logoSrc ? (_jsx(Image, { alt: "", height: 20, src: logoSrc, style: {
                borderRadius: '5px',
                objectFit: 'cover',
            }, width: 20 })) : (_jsx(FontAwesomeIcon, { height: "12px", iconName: "user-group", iconType: CATEGORIES.SOLID })), _jsx(Box, { font: "metadata-semibold-asphalt", ml: 1, children: _jsx(Dotdotdot, { clamp: 1, tagName: "span", children: groupName }) })] }));
//# sourceMappingURL=GroupSignature.js.map